import { combineReducers } from 'redux';
import { Map } from 'immutable';
import { createStructuredSelector } from 'reselect';

import {
	COUPON_CATEGORIES_CREATE,
	COUPON_CATEGORIES_CREATE_SUCCESS,
	COUPON_CATEGORIES_CREATE_FAIL,
	COUPON_CATEGORIES_UPDATE,
	COUPON_CATEGORIES_UPDATE_SUCCESS,
	COUPON_CATEGORIES_UPDATE_FAIL,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	COUPON_CATEGORIES_GET_DETAILS,
	COUPON_CATEGORIES_GET_DETAILS_SUCCESS,
	COUPON_CATEGORIES_GET_DETAILS_FAIL,
	OPTIONS_GET,
	OPTIONS_GET_SUCCESS,
	OPTIONS_GET_FAIL,
} from 'Constants/actionTypes';

const statusReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPON_CATEGORIES_CREATE:
		return state.set('couponCategory', 'creating');
	case COUPON_CATEGORIES_UPDATE:
		return state.set('couponCategory', 'submitting');
	case COUPON_CATEGORIES_CREATE_SUCCESS:
		return state.set('couponCategory', 'created');
	case COUPON_CATEGORIES_UPDATE_SUCCESS:
		return state.set('couponCategory', 'submitted');
	case COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state.set('couponCategories', 'fetching');
	case COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return state.set('couponCategories', 'fetched');
	case COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL:
		return state.set('couponCategories', 'has-errors');
	case COUPON_CATEGORIES_GET_DETAILS:
		return state.set('couponCategory', 'fetching');
	case COUPON_CATEGORIES_GET_DETAILS_SUCCESS:
		return state.set('couponCategory', 'fetched');
	case COUPON_CATEGORIES_CREATE_FAIL:
	case COUPON_CATEGORIES_UPDATE_FAIL:
	case COUPON_CATEGORIES_GET_DETAILS_FAIL:
		return state.set('couponCategory', 'has-errors');
	case OPTIONS_GET:
		return action.payload.tag === 'couponCategory' ? state.set('options', 'fetching') : state;
	case OPTIONS_GET_SUCCESS:
		return action.payload.tag === 'couponCategory' ? state.set('options', 'fetched') : state;
	case OPTIONS_GET_FAIL:
		return action.payload.tag === 'couponCategory' ? state.set('options', 'has-errors') : state;
	default:
		return state;
	}
};

const currentReducer = (state = null, action) => {
	switch (action.type) {
	case COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return null;
	case COUPON_CATEGORIES_CREATE_SUCCESS:
	case COUPON_CATEGORIES_UPDATE_SUCCESS:
	case COUPON_CATEGORIES_GET_DETAILS_SUCCESS:
		return action.payload.category;
	default:
		return state;
	}
};

const couponCategoriesByPageReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state;
	case COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return new Map(action.payload);
	default:
		return state;
	}
};

const couponCategoryReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COUPON_CATEGORIES_CREATE:
		return state;
	case COUPON_CATEGORIES_GET_DETAILS:
		return new Map();
	case COUPON_CATEGORIES_CREATE_SUCCESS:
	case COUPON_CATEGORIES_UPDATE_SUCCESS:
	case COUPON_CATEGORIES_GET_DETAILS_SUCCESS:
		return state.set(action.payload.category, action.payload);
	default:
		return state;
	}
};

const optionsReducer = (state = new Map(), action) => {
	switch (action.type) {
	case OPTIONS_GET:
		return action.payload.tag === 'couponCategory' ? new Map() : state;
	case OPTIONS_GET_SUCCESS:
		return action.payload.tag === 'couponCategory' ? new Map(action.payload.options) : state;
	default:
		return state;
	}
};

export default combineReducers({
	status: statusReducer,
	current: currentReducer,
	couponCategoriesByPage: couponCategoriesByPageReducer,
	couponCategory: couponCategoryReducer,
	options: optionsReducer,
});

export const selector = createStructuredSelector({
	status: (state) => state.couponCategories.status,
	current: (state) => state.couponCategories.current,
	couponCategoriesByPage: (state) => state.couponCategories.couponCategoriesByPage,
	couponCategory: (state) => state.couponCategories.couponCategory,
	options: (state) => state.couponCategories.options,
	errors: (state) => state.errors.get('couponCategory'),
});
